import { oneOf } from 'prop-types';

const inputType = oneOf(['email', 'number', 'search', 'string']);
const position = oneOf(['top', 'right', 'bottom', 'left']);

export { inputType, position };
